const userAction = {
    CANCEL : 'cancel',

    ACTIVATE : 'activate',

    DEACTIVATE : 'deactivate',

    RESET_PASSWORD : 'reset password',

    CREATE_PASSWORD : 'create password',

    UNLOCK : 'unlock',

    EDIT : 'startChanges',

    SAVE_CHANGES : 'applyChanges',

    CANCEL_EDIT : 'discardChanges'

};

angular.module('gw-um-j2js')
    .constant('userAction', userAction);